
import { Button } from "primereact/button";
import { NavLink } from "react-router-dom"; 

/**
 * 
 * @param {*} param0 
 */
 export const ButtonComponent = ({ url, label, action, className}) =>{
    return(
        <NavLink to={url}>
            <Button
                label={ label }
                icon="pi pi-arrow-right"
                iconPos="right"
                // className="p-button-rounded p-button-raised ui-button large-icon-button"
                className={className}
                onClick={()=> action()}
            >        
            </Button>
        </NavLink>
    )
}